import React from "react";
import ContentLoader from "react-content-loader";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function HomeMeeting(props) {
    const { t } = useTranslation();
    const demo_data = [{ id: 1 }, { id: 2 }, { id: 3 }];
    const selector = useSelector((state) => state.upcomingMeetingReducer);

    return (
        <>
        {!selector?.loading && selector?.data?.length > 0 ? (
        <div className="widget hm-widget mb-4">
            <h4 className="sv-suggest-heading">{t('Meetings')}</h4>
            <ul className="hm-list">
                {selector?.loading && demo_data?.map((post, i) => (
                    <li key={i} className="hm-item">
                        <ContentLoader
                            speed={2}
                            width={400}
                            height={60}
                            viewBox="0 0 400 60"
                            backgroundColor="#eeecec"
                            foregroundColor="#eae6e6"
                            {...props}
                        >
                            <circle cx="31" cy="31" r="15" />
                            <rect x="58" y="18" rx="2" ry="2" width="140" height="10" />
                            <rect x="58" y="34" rx="2" ry="2" width="140" height="10" />
                        </ContentLoader>
                    </li>
                ))}
                {!selector?.loading && selector?.data?.map((value, index) => (
                    <li className="hm-item" key={value.id ?? index}>
                        <div className="mh-date hm-date">
                            <div className="mh-date-day">{value.day}</div>
                            <div className="mh-date-month">{value.month}</div>
                            <div className="hm-time">{value.time}</div>
                        </div>

                        <div className="hm-body">
                            <div className="hm-title-row">
                                <Link to={`/meeting-details/${value.room_name}`} className="hm-title">{value.room_title}</Link>
                                {/* Live Now badge \u2014 updates in real-time via Soketi */}
                                {value.is_start == 1 && (
                                    <span className="hm-badge-live">
                                        <span className="hm-live-dot" />
                                        Live
                                    </span>
                                )}
                            </div>
                            <div className="mh-avatars">
                                {value.users.slice(0, 3).map((user, index) => (
                                    <Link to={`/contact/${user.id}`} key={user.id}>
                                        <div className="mh-avatar" style={{ backgroundImage: `url(${user.avatar})` }} />
                                    </Link>
                                ))}
                                {value.users.length > 3 ?
                                    <Link to={`/meeting-details/${value.room_name}`}>
                                        <div className="mh-avatar mh-avatar-more">+{value.users.length - 3}</div>
                                    </Link>
                                : ''}
                            </div>
                        </div>

                        {/* Quick-join button \u2014 only visible when meeting is live */}
                        {value.is_start == 1 && (
                            <Link to={`/meeting/${value.room_name}`} className="hm-join">
                                <i className="fa-solid fa-video" style={{ fontSize: 11 }} />
                                {t('Join')}
                            </Link>
                        )}
                    </li>
                ))}
            </ul>
        </div>
        ) : ''}
        </>
    );
}